/**
 * Types related to custom fields functionality
 */

/**
 * Possible data types for custom fields
 */
export enum CustomFieldDataType {
  TEXT = "TEXT",
  NUMBER = "NUMBER",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  DATETIME = "DATETIME",
  ARRAY = "ARRAY",
}

/**
 * Definition of a custom field.
 * Retrieved from the API and used to construct columns and filters.
 */
export interface CustomFieldDefinition {
  /** Unique identifier for the field */
  id: string;

  /** Human-readable name of the field */
  display_name: string;

  /** The data type of this field */
  data_type: CustomFieldDataType;

  /** The entity type this field applies to (e.g., "salesforce.account", "salesforce.contact") */
  record_type: string;

  /** Allowed enum values for the field (if provided by server) */
  value_enum?: string[];
}

/**
 * Map of selected custom field IDs to their definition objects
 */
export interface SelectedCustomFields {
  [fieldId: string]: CustomFieldDefinition;
}

/**
 * Filter definition for a custom field
 */
export interface CustomFieldFilter {
  /** ID of the custom field to filter by */
  fieldId: string;

  /** Operator to use (depends on data type) */
  operator: string;

  /** The value to compare against */
  value: unknown;
}
